import {
    GET_BUDGET_FEE_SCHEDULE,
    SET_BUDGET_DATA,
    GET_BUDGET_FEE_SCHEDULE_FAILED,
    SET_LOADING_BUDGET,
    REMOVE_LOADING_BUDGET
} from '../../types';

const initialState = {
    FeeSchedule: {
        schedule_type: null,
        set_up_fee: 0,
        monthly_admin_management_fee: 0,
        disposition_fee: 0,
        disposition_percentage: 0,
        contingency: 0,
        title_clearing_fee: 0,
        appraisal_fee: 0,
        contract_commission_rate: 0,
        participation: null,
        inspection_fee: 0
    },
    BudgetData: {},
    loading: false
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_BUDGET_FEE_SCHEDULE:
            return {
                ...state,
                FeeSchedule: { ...payload }
            };
        case SET_BUDGET_DATA:
            return {
                ...state,
                BudgetData: { ...payload }
            };
        case GET_BUDGET_FEE_SCHEDULE_FAILED:
            return {
                ...state,
                FeeSchedule: {},
                BudgetData: {}
            };
        case SET_LOADING_BUDGET:
            return {
                ...state,
                loading: true
            };
        case REMOVE_LOADING_BUDGET:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}